const n = {
  capture: (e) => {
    console.warn("no event resolver defined");
  }
};
export {
  n as EventResolver
};
//# sourceMappingURL=eventResolver.js.map
